import { FormikProps } from 'formik'
import { ThemeColorsFormInterface } from '~/src/components/layout/dev-mode/dialog'
import FormikTextField from '~/src/components/mui-wrappers/fields/FormikTextField'
import { Stack } from '@mui/material'

interface Props {
  form: FormikProps<ThemeColorsFormInterface>,
}

const MainGradientColors = ({ form }: Props) => {
  return (
    <Stack
      direction='row'
      gap={2}
      flexWrap='wrap'
      sx={{
        '& > *': {
          flex: '1 1 100px'
        }
      }}>
      <FormikTextField
        TextFieldProps={{
          fullWidth: true,
          form,
          color: 'content',
          name: 'main_gradient_color_from',
          label: 'Theme main color gradient start:',
          type: 'color',
          size: 'small',
          helperText: form.values.main_gradient_color_from
        }}
      />
      <FormikTextField
        TextFieldProps={{
          form,
          color: 'content',
          name: 'main_gradient_color_to',
          label: 'Theme main color gradient end:',
          type: 'color',
          size: 'small',
          helperText: form.values.main_gradient_color_to
        }}
      />
      <FormikTextField
        TextFieldProps={{
          form,
          color: 'content',
          name: 'main_gradient_contrast_color',
          label: 'Theme main color gradient contrast:',
          type: 'color',
          size: 'small',
          helperText: form.values.main_gradient_contrast_color
        }}
      />
    </Stack>
  )
}

export default MainGradientColors
